import { PublicUtils } from './PublicUtils';

export class FormsUtils{
    utils = new PublicUtils();
    
    orderBy($progs,$field){
        let data:any = [];
        let arr:any = [];
        if ($field=='nameSena'){
            for(let i = 0; i < $progs.length; i++){
                const paragraph = 'Técnico';
                const regex = /Técnico/i;
                const found = paragraph.match(regex);

                if($progs[i][$field].match(/Técnico/i)){
                    arr.push("1");
                    $progs[i]['senaType']="1";
                }else if($progs[i][$field].match(/Tecnolo/i)){
                    arr.push("2");    
                    $progs[i]['senaType']="2";
                }
            }
        }else{
            for(let i = 0; i < $progs.length; i++){
                arr.push($progs[i][$field]);
            }
        }
        let fields:any = this.utils.deleteArrayDuplicates(arr);
        for(let i = 0; i < fields.length; i++){
            let obj = {name:"", code:fields[i], programs:[], id:''};
            switch($field){
                case 'programType':
                    obj.name = this.utils.labelsTypes(fields[i]);
                break;
                case 'modality':
                    obj.name = this.utils.labelsModal(fields[i]);
                break;
                case 'site':
                    obj.name = fields[i].siteLabel;
                break;
                case 'nameSena':
                    obj.name = fields[i] == "1" ? "TÉCNICO":"TECNÓLOGO";
                    obj.id = fields[i] == "1" ? "radioTecnico":"radioTecnologo";
                break;
            }
            for(let j = 0; j < $progs.length; j++){
                if ($field != 'nameSena'){                
                    if($progs[j][$field] == obj.code && $progs[j].status == "ACT"){
                        if($field == "site"){
                            obj.name = $progs[j].siteLabel;
                        }
                        obj.programs.push($progs[j]);
                    }
                }else{
                    if($progs[j]['senaType'] == obj.code){
                        obj.programs.push($progs[j]);
                    }
                }
            }
            if(obj.code != "0"){
                data.push(obj);
            }
           
        }
        return data;
    }

    getPattern(option) {
        let pattern;
        switch (option) {
            case 'LETTERS':
                pattern = { code: '[a-zA-Z\s]{1,}', title:'Sólo se admiten letras' };
                break;
            case 'NUMBERS':
                pattern = { code: '^[1-9][0-9]{5,13}$', title: 'Sólo se admiten números' };
                break;
            case 'LETTERS+CHARS':
                pattern = { code: '[a-zA-Z-]', title: 'Sólo se admiten letras y guiones' };
                break;
            case 'LETTERSNUMBERS':
                pattern = { code: '^[1-9A-Za-z][0-9A-Za-z]{5,13}$', title: 'Sólo se admiten letras y números' };
                break;
            case 'LETTERS+CHARS+NUMBERS':
                pattern = { code: '[a-zA-Z0-9-.,;:&]', title: 'Sólo se admiten letras y caracteres alfanuméricos' };
                break;
        }
        return pattern;
    }

    loadMessage($obj){
        let message = "";
        let centinela = false;
        for(let name in $obj){
            let campo = "";
            switch(name){
                case 'program':
                    campo = "programa";
                break;
                case 'name':
                    campo = "nombre";
                break;
                case 'lastName':
                    campo = "apellido";
                break;
                case 'email':
                    campo = "email";
                break;
                case 'celphone':
                    campo = "celular";
                break;
                case 'numDoc':
                    campo = "número de documento";
                break;
                case 'state':
                    campo = "departamento";
                break;
                case 'city':
                    campo = "ciudad";
                break;
                case 'terms':
                    campo = "términos y condiciones";
                break;
                case 'programType':
                    campo = "tipo de programa";
                break;
                case 'titulo':
                    campo = "titulo";
                break;
                case 'site':
                    campo = "sede";
                break; 
                case 'modality':
                    campo = "modalidad";
                break;                
            }
            if($obj[name].status == "INVALID" && centinela == false){
                centinela = true;
                if($obj[name].errors.required){
                    message = `El campo ${campo} es obligatorio`;
                }
                if($obj[name].errors.pattern){
                    message = `El campo ${campo} no contiene el formato adecuado`;
                }
                if($obj[name].errors.email){
                    message = `Debes ingresar un email valido`;
                }
            }
        }
        return message;
    }

} 